(() => {
  const EXPERIMENT_ID = 'cookie_trigger_v1';
  const EXPERIMENT_PARAM = 'exp_cookie_trigger_v1';
  const EXPERIMENT_STORAGE_KEY = '__x4_exp_cookie_trigger_v1';
  const VISITOR_STORAGE_KEY = '__x4_vid';
  const TTL_DAYS = 30;
  const VARIANTS = ['control', 'variant'];

  function parseJson(raw) {
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  }

  function getCookie(name) {
    const pattern = new RegExp(`(?:^|; )${name}=([^;]*)`);
    const match = document.cookie.match(pattern);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function readStoredVariant() {
    let stored = null;

    try {
      stored = parseJson(localStorage.getItem(EXPERIMENT_STORAGE_KEY));
    } catch (error) {
      stored = null;
    }

    if (!stored || !stored.variant) {
      try {
        stored = parseJson(getCookie(EXPERIMENT_STORAGE_KEY));
      } catch (error) {
        stored = null;
      }
    }

    if (!stored || !stored.variant || !stored.expires_at) return null;
    if (Date.now() > stored.expires_at) return null;
    return stored.variant;
  }

  function writeStoredVariant(variant) {
    const payload = {
      variant: variant,
      assigned_at: Date.now(),
      expires_at: Date.now() + TTL_DAYS * 24 * 60 * 60 * 1000
    };

    try {
      localStorage.setItem(EXPERIMENT_STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {
      /* no-op */
    }

    setCookie(EXPERIMENT_STORAGE_KEY, JSON.stringify(payload), TTL_DAYS);
  }

  function getOverrideVariant() {
    const params = new URLSearchParams(window.location.search);
    const forcedVariant = (params.get(EXPERIMENT_PARAM) || '').toLowerCase();
    return VARIANTS.includes(forcedVariant) ? forcedVariant : null;
  }

  function generateVisitorId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return `x4-${Date.now()}-${Math.floor(Math.random() * 1e8)}`;
  }

  function getVisitorId() {
    try {
      const localId = localStorage.getItem(VISITOR_STORAGE_KEY);
      if (localId) return localId;
    } catch (error) {
      /* no-op */
    }

    const cookieId = getCookie(VISITOR_STORAGE_KEY);
    if (cookieId) return cookieId;

    const newId = generateVisitorId();

    try {
      localStorage.setItem(VISITOR_STORAGE_KEY, newId);
    } catch (error) {
      /* no-op */
    }

    setCookie(VISITOR_STORAGE_KEY, newId, 365);
    return newId;
  }

  function hashString(input) {
    let hash = 0;
    for (let index = 0; index < input.length; index += 1) {
      hash = (hash << 5) - hash + input.charCodeAt(index);
      hash |= 0;
    }
    return Math.abs(hash);
  }

  function chooseVariant() {
    const visitorId = getVisitorId();
    const bucket = hashString(`${EXPERIMENT_ID}:${visitorId}`) % 2;
    return bucket === 0 ? 'control' : 'variant';
  }

  function publishEvent(eventName, payload) {
    const eventPayload = Object.assign(
      {
        experiment_id: EXPERIMENT_ID,
        variant_id: resolvedVariant,
        page_path: window.location.pathname,
        timestamp: new Date().toISOString()
      },
      payload || {}
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      Object.assign(
        {
          event: eventName
        },
        eventPayload
      )
    );

    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      try {
        window.Shopify.analytics.publish(eventName, eventPayload);
      } catch (error) {
        /* no-op */
      }
    }
  }

  function publishAssignmentOnce(source) {
    const sessionKey = `__x4_exp_cookie_trigger_v1_assigned_${window.location.pathname}`;
    let alreadyPublished = null;

    try {
      alreadyPublished = sessionStorage.getItem(sessionKey);
    } catch (error) {
      alreadyPublished = null;
    }

    if (alreadyPublished === resolvedVariant) return;

    try {
      sessionStorage.setItem(sessionKey, resolvedVariant);
    } catch (error) {
      /* no-op */
    }

    publishEvent('exp_variant_assigned', {
      assignment_source: source
    });
  }

  function applyVariantToDom(variant) {
    document.documentElement.dataset.expCookieTriggerV1 = variant;
    if (document.body) {
      document.body.classList.add(`exp-cookie-trigger-v1-${variant}`);
    }
  }

  function resolveCookieConfig(variant) {
    if (variant === 'variant') {
      return {
        mode: 'delay_or_scroll',
        delayMs: 3000
      };
    }

    return {
      mode: 'immediate'
    };
  }

  const forcedVariant = getOverrideVariant();
  let resolvedVariant = forcedVariant || readStoredVariant();
  let assignmentSource = 'persisted';

  if (!resolvedVariant) {
    resolvedVariant = chooseVariant();
    writeStoredVariant(resolvedVariant);
    assignmentSource = 'generated';
  } else if (forcedVariant) {
    assignmentSource = 'query_override';
  }

  if (!VARIANTS.includes(resolvedVariant)) {
    resolvedVariant = 'control';
  }

  applyVariantToDom(resolvedVariant);

  window.__x4CookieTriggerExperiment = {
    experiment_id: EXPERIMENT_ID,
    variant_id: resolvedVariant
  };

  window.__x4CookieTriggerConfig = resolveCookieConfig(resolvedVariant);

  document.addEventListener('DOMContentLoaded', () => {
    applyVariantToDom(resolvedVariant);
    publishAssignmentOnce(assignmentSource);
  });
})();
